<template>
  <div>
    <p>test</p>
    <line v-if="staticChartData" :data="staticChartData" :options="chartOptions"></line>
  </div>
</template>

<script>
/* eslint-disable */
import { Line } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement)

export default {
  name: 'LineChart',
  components: {
    Line
  },
  data() {
    return {
      staticChartData: {
        labels: Array.from({ length: 150 }, (_, i) => i),
        datasets: [
          {
            label: 'Static Data',
            backgroundColor: '#42A5F5',
            borderColor: '#42A5F5',
            data: Array.from({ length: 150 }, () => Math.random() * 100)
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Index'
            }
          },
          y: {
            title: {
              display: true,
              text: 'Value'
            }
          }
        }
      }
    }
  },
  mounted() {
    console.log('staticChartData:', this.staticChartData)
    console.log('chartOptions:', this.chartOptions)
  }
}
</script>

<style scoped>
div {
  height: 400px;
  position: relative;
}
</style>
